import { EnvelopeClosedIcon } from '@radix-ui/react-icons';
import { Box, Text } from '@radix-ui/themes';
import { SettingButton } from 'components/common/settings-dialog/button';
import { SettingForm } from 'components/common/settings-dialog/form';
import { SettingRow } from 'components/common/settings-dialog/row';
import { t } from 'i18next';
import { UserStatus } from 'lib_ts/enums/auth.enums';
import { IUser } from 'lib_ts/interfaces/i-user';
import { useEffect, useState } from 'react';
import { AuthService } from 'services/auth.service';

const MAX_ADMINS_DISPLAYED = 3;

export const UserSectionTeamAdmins = () => {
  const [admins, setAdmins] = useState<IUser[]>([]);

  useEffect(() => {
    AuthService.getInstance()
      .getTeamAdmins()
      .then((admins) => setAdmins(admins));
  }, []);
  return (
    <SettingForm>
      <Box>{t('settings.api-keys-msg')}</Box>

      {admins
        .filter((a) => a.status === UserStatus.verified)
        .filter((_, i) => i < MAX_ADMINS_DISPLAYED)
        .map((a, i) => (
          <SettingRow
            key={i}
            header={a.email}
            description={
              <Text className="text-titlecase">
                {a.role.split('-').join(' ')}
              </Text>
            }
            input={
              <SettingButton
                icon={<EnvelopeClosedIcon />}
                label="settings.contact"
                onClick={() => window.open(`mailto:${a.email}`)}
              />
            }
          />
        ))}
    </SettingForm>
  );
};
